import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initBaiduTongji, trackBaiduPageView } from "../utils/baiduTongji";
import { initToutiaoAutoPush } from "../utils/toutiaoAutoPush";
import { recordSitePageView } from "../utils/siteAnalytics";

export default function SiteAnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    initBaiduTongji();
    initToutiaoAutoPush();
  }, []);

  useEffect(() => {
    const { pathname, search } = location;
    trackBaiduPageView(pathname, search);
    recordSitePageView(pathname, search);
  }, [location.pathname, location.search]);

  return null;
}
